/**
 * The TypeScript mirror of tokens.css. Only the values code genuinely needs live here:
 * breakpoints (media queries built in JS) and the z-index scale (portals). Colour, type,
 * spacing, radius and motion stay in CSS. If you need one of those in TSX, you need a class.
 */

export const BREAKPOINTS = {
  phoneMax: 767,
  tabletMin: 768,
  desktopMin: 1024,
  wideMin: 1280,
} as const;

export const MEDIA = {
  phone: `(max-width: ${BREAKPOINTS.phoneMax}px)`,
  tabletUp: `(min-width: ${BREAKPOINTS.tabletMin}px)`,
  desktopUp: `(min-width: ${BREAKPOINTS.desktopMin}px)`,
  wideUp: `(min-width: ${BREAKPOINTS.wideMin}px)`,
  reducedMotion: '(prefers-reduced-motion: reduce)',
} as const;

/** Mirrors the --z-* scale. Components read these through the `z` CSS var names, not here. */
export const Z = {
  base: 0,
  stickyHeader: 10,
  queueRail: 20,
  topBar: 30,
  bottomTabs: 40,
  drawerScrim: 50,
  drawer: 60,
  dialogScrim: 70,
  dialog: 80,
  commandPalette: 90,
  toast: 100,
  lockScreen: 200,
} as const;

/** Column priority collapse points, mirrored from DESIGN.md section 5. */
export const COLUMN_PRIORITY_HIDDEN_BELOW = {
  5: BREAKPOINTS.wideMin,
  4: BREAKPOINTS.desktopMin,
} as const;

/** Rows above this switch to a virtualized body. DESIGN.md section 4. */
export const VIRTUALIZE_AFTER_ROWS = 60;
